import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from 'vue';
import apis from "@/api";
import { getUserManager, updateUserManager, deleteUserManager } from "../../../../api/modules/system";
const reg_fgs = new RegExp("分公司", "g"); //创建正则RegExp对象
export default {
  components: {},
  name: "ManagerAssign",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const data = reactive({
      userInfo: {},
      sysManager: {},
      roleList: [],
      queryParam: {
        empName: "",
        status: '1',
        mobile: "",
        limitName: ""
      },
      pageNo: 1,
      pageSize: 5,
      tableData: [],
      allData: [],
      columns: [{
        label: "账号",
        prop: "userId",
        width: "10%"
      }, {
        label: "姓名",
        prop: "empName",
        width: "12%"
      }, {
        label: "手机",
        prop: "mobile",
        width: "11%"
      }, {
        label: "组织结构",
        prop: "limitName",
        width: "30%",
        formatter: val => {
          if (val) {
            let s = val.replace('组织机构/', '');
            return s.replace(reg_fgs, '');
          }
        }
      }],
      total: 0,
      currentPage: 1,
      searchFlag: false
    });
    const {
      proxy
    } = getCurrentInstance();
    const initUserManager = userInfo => {
      console.log("传过来的userInfo:", userInfo);
      data.userInfo = userInfo;
      if (undefined === data.userInfo) {} else {
        apis.getUserManager({
          userId: userInfo.userId
        }).then(res => {
          if (res.success) {
            console.log("sysManager-res.data", res.data);
            data.sysManager = res.data;
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    const deleteManager = () => {
      apis.deleteUserManager({
        userId: data.userInfo.userId
      }).then(res => {
        if (res.success) {
          console.log("delete temp manager success!");
          apis.getUserManager({
            userId: data.userInfo.userId
          }).then(res => {
            if (res.success) {
              data.sysManager = res.data;
            } else {
              ElMessage.error(res.msg);
            }
          });
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const resetForm = form => {
      proxy.$refs[form].resetFields();
    };
    const submitForm = form => {
      proxy.$refs[form].validate(valid => {
        if (valid) {
          data.searchFlag = true;
          apis.getAccountList({
            pageNo: data.currentPage,
            pageSize: data.pageSize,
            empName: data.queryParam.empName,
            userType: data.queryParam.userType,
            mobile: data.queryParam.mobile,
            status: data.queryParam.status,
            limitName: data.queryParam.limitName
          }).then(res => {
            data.total = res.data.total;
            data.tableData = res.data.records;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
    const loadData = () => {
      apis.getAccountList({
        pageNo: data.pageNo,
        pageSize: data.pageSize,
        status: data.queryParam.status
      }).then(res => {
        if (res.success) {
          console.log("manager-res:", res);
          data.total = res.data.total;
          data.tableData = res.data.records;
        }
      });
    };
    const sizeChange = pageSize => {
      this.pageSize = pageSize;
      this.currentChange(this.currentPage);
    };
    const currentChange = currentPage => {
      console.log("currentPage:", currentPage);
      if (data.searchFlag) {
        apis.getAccountList({
          pageNo: currentPage,
          pageSize: data.pageSize,
          empName: data.queryParam.empName,
          mobile: data.queryParam.mobile,
          limitName: data.queryParam.limitName
        }).then(res => {
          console.log("current:records->", res);
          data.total = res.data.total;
          data.tableData = res.data.records;
        });
      } else {
        apis.getAccountList({
          pageNo: currentPage,
          pageSize: data.pageSize,
          status: data.queryParam.status
        }).then(res => {
          data.total = res.data.total;
          data.tableData = res.data.records;
        });
      }
    };
    onMounted(() => {
      loadData();
    });
    const close = () => {
      context.emit('update:visible', false);
    };
    const handleManager = row => {
      if (row.userId) {
        const {
          userId,
          empName,
          mobile,
          limitName
        } = data.userInfo;
        const mngerParam = {
          managerNum: row.employeeNo,
          managerName: row.empName,
          managerLimit: row.limitName,
          userId,
          userName: empName,
          userMobile: mobile,
          userLimit: limitName
        };
        let oriMngerParam = {};
        if (data.sysManager) {
          const {
            originManagerName,
            originManagerNum,
            originManagerLimit
          } = data.sysManager;
          oriMngerParam = {
            originManagerName,
            originManagerNum,
            originManagerLimit
          };
        }
        apis.updateUserManager({
          ...mngerParam,
          ...oriMngerParam
        }).then(res => {
          if (res.success) {
            console.log("updateManager-->success");
            apis.getUserManager({
              userId: data.userInfo.userId
            }).then(res => {
              if (res.success) {
                data.sysManager = res.data;
              } else {
                ElMessage.error(res.msg);
              }
            });
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    onMounted(() => {
      // initUserManager(data.userInfo)
    });
    return {
      ...toRefs(data),
      close,
      initUserManager,
      deleteManager,
      submitForm,
      resetForm,
      loadData,
      sizeChange,
      currentChange,
      handleManager
    };
  }
};